import { render, staticRenderFns } from "./RolesCell.vue?vue&type=template&id=b72ad908&scoped=true&"
import script from "./RolesCell.vue?vue&type=script&lang=js&"
export * from "./RolesCell.vue?vue&type=script&lang=js&"
import style0 from "./RolesCell.vue?vue&type=style&index=0&id=b72ad908&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b72ad908",
  null
  
)

export default component.exports